import { Article } from '../types';
import { RouterState } from '../routerMiddleware';
import { useEffect } from 'react';
import { useRoute } from 'react-router5';

import hljs from 'highlight.js/lib/core';
import c from 'highlight.js/lib/languages/c';
import cpp from 'highlight.js/lib/languages/cpp';
import shell from 'highlight.js/lib/languages/shell';
import python from 'highlight.js/lib/languages/python';
import diff from 'highlight.js/lib/languages/diff';
import json from 'highlight.js/lib/languages/json';
import rust from 'highlight.js/lib/languages/rust';
import toml from 'highlight.js/lib/languages/ini';
import yaml from 'highlight.js/lib/languages/yaml';
import javascript from 'highlight.js/lib/languages/javascript';
import armasm from 'highlight.js/lib/languages/armasm';
import java from 'highlight.js/lib/languages/java';
import xml from 'highlight.js/lib/languages/xml';

hljs.registerLanguage('c', c);
hljs.registerLanguage('cpp', cpp);
hljs.registerLanguage('shell', shell);
hljs.registerLanguage('python', python);
hljs.registerLanguage('diff', diff);
hljs.registerLanguage('json', json);
hljs.registerLanguage('rust', rust);
hljs.registerLanguage('toml', toml)
hljs.registerLanguage('yaml', yaml);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('armasm', armasm);
hljs.registerLanguage('java', java);
hljs.registerLanguage('xml', xml);

export default function useArticle(): Article | null {
  const { route } = useRoute();
  const state = route as RouterState;

  useEffect(() => {
    document.querySelectorAll('code').forEach((block) => {
      hljs.highlightElement(block);
    });
  }, []);
    
  return state?.data?.articles.find(a => a.id == route.params.id) || null;
}
